// extracted by mini-css-extract-plugin
export default {"authContainer":"authScreen_authContainer__FuEKO","authFormContainer":"authScreen_authFormContainer__15pnT","authForm":"authScreen_authForm__d34Kg"};